import styled from 'styled-components';

export const Container = styled.div`

`;

export const WrapperButton = styled.span`
  cursor: pointer;
`;
